<template>
  <div class="nav-cont">
    <div>
      <nav
        v-for="(item,index) in navList"
        :key="index"
        v-if="!hideTitleArray[index]"
        @click="changeActive(index)"
        :class="{active: activeIndex == index}"
      >{{item.title}}</nav>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    navList: {
      type: Array,
      default: []
    },
    hideTitleArray: {
      type: Array,
      default: [] //type没有则 隐藏对应title
    }
  },
  data() {
    return {
      activeIndex: 0
    };
  },
  mounted() {
    this.showDefaultItem(); // 展示默认第一个有的选项
  },
  methods: {
    changeActive(index) {
      this.activeIndex = index;
      this.$emit("changeTab", this.activeIndex);
      // if (!index) {
      let dom = document.querySelector(".header");
      dom.scrollIntoView({
        behavior: "smooth"
      });
      // } else {
      //     let dom = document.querySelector('.swiper-wrapper')
      //     dom.scrollIntoView({
      //         behavior: 'smooth'
      //     })
      // }
    },
    showDefaultItem() {
      for (let i = 0, len = this.hideTitleArray.length; i < len; i++) {
        if (!this.hideTitleArray[i]) {
          this.activeIndex = i;
          this.$emit("changeTab", this.activeIndex);
          return;
        }
      }
    }
  }
};
</script>


<style lang="less">
.nav-cont {
  padding: 0 2%;
  box-sizing: border-box;
  text-align: center;
  border-radius: 5px;
  position: sticky;
  top: 0;
  margin-top: -0.6rem;
  z-index: 10;
  &:before {
    content: "";
    display: block;
    position: absolute;
    top: -4.5rem;
    width: 90%;
    left: 10%;
    height: 4.7rem;
    background: url("//pic1.58cdn.com.cn/nowater/jltx/n_v2c8fede399a7144b191eb7f1c0508402f.png")
      no-repeat center;
    background-size: contain;
  }
  > div {
    background: #367076;
    border-radius: 8px;
    // display: flex;
    // justify-content: space-around;
  }
  nav {
    font-size: 0.4rem;
    color: #fff;
    padding-top: 0.2rem;
    padding-bottom: 0.2rem;
    border-radius: 5px;
    display: inline-block;
    width: 25% !important;
    // flex: 1;
    // padding: 30px 25px;
    &.active {
      background: linear-gradient(#ffd704, #fda415);
      color: #451f00;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/base/baseNav.vue